import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../../Components/Tabs'
import GetIcon from '../../../../../utils/Icon'
import { Link, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Table from './Table'
import { usePostItemListMutation, } from "../../../../../store/api/purchaseorderapi";
import { usePostSalesOrderCreateMutation, usePostSalesOrderSubmitMutation, usePostFrappeClientGetMutation, usePostSalesOrderUpdateMutation } from "../../../../../store/api/salesorderapi";
import Button from '../../../../../Core/Button/Button'
import printerimg from "../../../../../assets/print.png"
import ApiResponseBox from '../../../../../Components/ApiResponseBox'
import BulkUpload from '../Create-Sales-Order/BulkUpload'
import { useGetPaymentTermsQuery } from '../../../../../store/api/paymenttermapi'
import { useGetCurrencyListQuery, useGetSelectedCompanyQuery } from '../../../../../store/api/companyapi'
import { useGetPriceListQuery } from "../../../../../store/api/pricelistapi";
import { useGetSalesTaxCategoryListQuery, useGetTaxCategoryListQuery } from "../../../../../store/api/taxcategoryapi";
import { useGetTermsandConditionQuery } from "../../../../../store/api/termsandconditionapi";
import { useGetCostCenterListQuery } from "../../../../../store/api/costcenterapi";
import { useGetProjectListQuery } from "../../../../../store/api/projectapi";
import Attachment from '../../../../../utils/Attachment'

function Salesform({ salesorderId }) {
    const [customer, setcustomer] = useState();
    const [selected_item_data, setselected_item_data] = useState([]);
    const [allitems, setallitems] = useState([]);
    const [fulldata, setfulldata] = useState([]);
    const [po_status, setpo_status] = useState('');

    const [termsandcondition, settermsandcondition] = useState([]);
    const [taxandchanges, settaxandchanges] = useState('');
    const [paymentterm, setpaymentterm] = useState([]);
    const [currency, setcurrency] = useState('');
    const [pricel, setpricel] = useState('');
    const [project, setproject] = useState('');
    const [cost_center, setcost_center] = useState('');
    const [genaralData, setgenaralData] = useState();

    const [rows, setRows] = useState([{
        item_code: "",
        item: {},
        required_by: "",
        quantity: 1,
        uom: "",
        rate: "0",
        amount: "0",
    }]);
    const [showpopup, setShowpopup] = useState(false);
    const [tab1Data, setTab1Data] = useState({
        orderNo: '',
        date: '',
        customer: '',
        dueDate: '',
        order_type: '',
        billingType: '',
    });
    const [ptype, setptype] = useState("Error ")
    const { data: p_term } = useGetPaymentTermsQuery();
    const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ selling: 1 }) });
    const { data: currencylist } = useGetCurrencyListQuery();
    // const { data: taxandchangeslist } = useGetTaxCategoryListQuery();
    const { data: tandc } = useGetTermsandConditionQuery();
    const { data: projectlist } = useGetProjectListQuery();
    const { data: companydata } = useGetSelectedCompanyQuery();
    const selectedComapny = companydata?.message?.data?.company;
    const { data:taxandchangeslist } = useGetSalesTaxCategoryListQuery(selectedComapny);
    const [postFrappeClientGet, { data, errors }] = usePostFrappeClientGetMutation();
       const filters = [
    ["company", "=", selectedComapny?.split(" - ")[0]],
    ["disabled", "=", 0],
    ["is_group", "=", 0]
  ];
  const { data:costcenterlist } = useGetCostCenterListQuery({filters: JSON.stringify(filters)});
   const fetchData = async () => {
            try {
                const payload = {
                    doctype: 'Sales Order',
                    name: salesorderId,
                };

                const res1 = await postFrappeClientGet(payload).unwrap();
                setfulldata(res1)
                setgenaralData(res1?.message)
                
                setorderNo(res1.message.name)
                console.log("First response:", res1);
                setcustomer(res1.message.customer_name,)
                setcost_center(res1.message.cost_center)
                setproject(res1.message.project)
                setcurrency(res1.message.currency)
                setpaymentterm(res1.message.payment_terms_template)
                setpricel(res1.message.selling_price_list)
                settaxandchanges(res1.message.tax_category)
                settermsandcondition(res1.message.tc_name)
                const newData = {
                    orderNo: res1.message.name,
                    customer: res1.message.customer_name,
                    order_type: res1.message.order_type,
                    dueDate: res1.message.delivery_date,
                    date: res1.message.creation,
                    billingType: res1.message?.custom_billing_type
                };

                setTab1Data(prev => ({
                    ...prev,
                    ...newData,
                }));

                const items = res1.message.items || [];
                setallitems(items)
                if (res1.message.status === 'Draft') {
                    setpo_status('');
                } else {
                    setpo_status(res1.message.status);
                }

            } catch (err) {
                console.error('Error during fetch:', err);
            }
        };
    useEffect(() => {
        fetchData();
    }, []);


    const [postSalesOrderCreate, { isLoading, isSuccess, isError }] = usePostSalesOrderUpdateMutation();


    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)

    const [tab, settab] = useState(1)
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');

    
    // genaralData
    // const [errorMessages, setErrorMessages] = useState([]);

    const [fieldErrors, setFieldErrors] = useState({
        customer: false,
        dueDate: false,
        billing_address: false,
        shipping_address: false,
        billingType: false,
        order_type: false,
        items: false
    });

    console.log(fieldErrors, "fieldErrors");

    const [po_response, setpo_response] = useState("");
    const [getitem_list_data] = usePostItemListMutation();
   console.log("po_responsepo_responsepo_response",po_response);

    const totalQuantity = selected_item_data.reduce((total, item) => {
        return total + parseFloat(item.quantity || 0);
    }, 0)
    console.log(selected_item_data, "selected_item_data");


    const [showDropdown, setShowDropdown] = useState(false);
    const handleNavigate = (path) => {
        nvg(path);
        setShowDropdown(false);
    };


    const [tab1CustomerData, setTab1CustomerData] = useState({});
    const [orderNo, setorderNo] = useState('');

    const [tab2Data, setTab2Data] = useState({});


    function toTitleCase(str) {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    const handleSave = async () => {

        const errors = {
            name: !tab1Data.orderNo,
            customer: !tab1Data.customer,
            dueDate: !tab1Data.dueDate,
            billing_address: !tab2Data.billing_address,
            shipping_address: !tab2Data.shipping_addresses,
            billingType: !tab1Data.billingType,
            order_type: !tab1Data.order_type,
            items: selected_item_data.length === 0 || selected_item_data.some(item => !item.item_code || !item.quantity)
        };

        setFieldErrors(errors);

        const missingFields = [];

        if (errors.customer) missingFields.push("Customer,");
        if (errors.delivery_date) missingFields.push("Delivery Date,");
        if (errors.billing_address) missingFields.push("Billing Address,");
        if (errors.shipping_address) missingFields.push("Shipping Address,");
        if (errors.custom_billing_type) missingFields.push("Billing Type,");
        if (errors.order_type) missingFields.push("Order Type,");
        if (errors.items) missingFields.push("At least one valid item (with code and quantity),");
        if (errors.name) missingFields.push(" Sales Order No");
        if (missingFields.length > 0) {
            setError(missingFields);
            setptype('Error This field is required')
            setShowError(true);
            return;
        }


        const payload = {
            name: tab1Data.orderNo,
            date: tab1Data.date || "",
            customer: tab1Data.customer?.split(" - ")[0] || "",
            delivery_date: tab1Data.dueDate || "",
            items: selected_item_data.map(item => ({
                item_code: item.item_code,
                quantity: parseInt(item.quantity) || 1
            })),
            billing_address: tab2Data.billing_address || "",
            shipping_address: tab2Data.shipping_addresses || "",
            custom_billing_type: tab1Data.billingType ? toTitleCase(tab1Data.billingType) : "",
            order_type: tab1Data.order_type ? toTitleCase(tab1Data.order_type) : "",
            "currency": currency,
            "price_list": pricel,
            "cost_center": cost_center,
            "project": project,
            "tax_category": taxandchanges,
            "payment_terms_template": paymentterm,
            "terms_and_conditions": termsandcondition,
        };

        console.log(payload, "payload85");

        try {
            const response = await postSalesOrderCreate(payload).unwrap();


            setpo_response(response);
            setorderNo(response.data);
            setItem(true);
			fetchData();

            setError('Updated');
            setptype('Sales Order Updated')
            setShowError(true);
            console.log("Order No:", response.data);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };

    const [activityboll, setactivityboll] = useState(false)
    const [submitSalesOrder] = usePostSalesOrderSubmitMutation();

    const handleSubmit = async () => {
        const payload = { sales_order_name: salesorderId };

        try {
            const res = await submitSalesOrder(payload);
            fetchData();
            // Check if response contains an error message
            if (res.status === 400) {
                // Handle the specific error returned by the API
                const errorMessage = res?.data?.message || 'Unexpected error occurred';
                setError('Error');
                setptype(errorMessage);
                setShowError(true);
                console.error('Error message from API:', errorMessage);
                return;  // Stop further execution
            }

            // Success
            setButtonData(true);
            setactivityboll(true);
            setError('submitted');
            setptype('Sales Order submitted');
            setShowError(true);
            setpo_status('submitted')

        } catch (err) {
            // If there’s a network error or any other error in the request
            console.error("Error caught:", err);
            const errorMessage = err?.data?.message || 'Unexpected error occurred';
            setError('Error');
            setptype(errorMessage);
            setShowError(true);
        }
    };

    const handleCreatePicklist = () => {
        nvg('/outbound/pick/createpick', {
            state: {
                order_id: fulldata?.message?.name
            }
        });
    };

    const handleDuplicate = async (id) => {
        try {
            nvg(`/outbound/outbound-sales-order-duplicate/`, { state: { salesorder: fulldata?.message?.name } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };


    return (
			<>
				<Tabs />
				<div
					className="d-flex justify-content-between p-2 "
					style={{ background: "#fcfdfe", height: "40px" }}
				>
					<div className="d-flex align-items-center customizewidth">
						<p className="m-0 breadcrumb-item">Outbound</p>
						<p className="m-0 ">
							{" "}
							<GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} />{" "}
						</p>
						<p
							className="m-0 breadcrumb-item"
							style={{ cursor: "pointer" }}
							onClick={() => nvg("/outbound/outbound-sales-order")}
						>
							Sales Order List{" "}
						</p>
						<p className="m-0 ">
							{" "}
							<GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} />{" "}
						</p>
						<a
							href="javascript:void(0);"
							className="pagetitle d-flex align-items-center mainpage"
							style={{
								borderBottom: "0px solid",
								textWrap: "nowrap",
								gap: "5px",
								color: "#270B79",
								fontSize: "",
							}}
						>
							Edit Sales Order
							<button
								className={`rounded-pill ${
									fulldata?.message?.status === "Draft"
										? "newdesign2343"
										: "newdesign123"
								}`}
							>
								{fulldata?.message?.status || "New"}
							</button>
						</a>
					</div>

					<div
						className="d-flex align-items-center justify-content-end customizewidth"
						style={{ gap: "5px" }}
					>
						{(fulldata?.message?.status === "To Deliver and Bill" ||
							fulldata?.message?.status === "Pick Created" ||
							po_status === "submitted") && (
							// <div
							// 	style={{
							// 		position: "relative",
							// 		display: "inline-block",
							// 		height: "28px",
							// 	}}
							// >
							// 	<div className="bustom-btn-00989">
							// 		<div
							// 			onClick={handleCreatePicklist}
							// 			className="custom-btn-blue852 createbtn d-flex"
							// 			style={{ gap: "2px", height: "28px" }}
							// 		>
							// 			<GetIcon iconName={"FaPlus"} size={12} />
							// 			Pick List
							// 		</div>
							// 	</div>
							// </div>
							<div style={{ position: 'relative', display: 'inline-block', height: '28px' }}>
															<NavLink
																onClick={() => setShowDropdown(prev => !prev)}
																className="createbutton m-0"
																style={{ color: "#391F84", borderRadius: "3px", cursor: 'pointer', height: '28px' }}
															>
																Create
																<span className="iconbox ps-2">
																	<GetIcon iconName="IoMdArrowDropdown" size={14} />
																</span>
															</NavLink>
							
															{showDropdown && (
																<div className="create-dropdown">
																	<div onClick={handleCreatePicklist} className="menu-item">
																		Pick List
																	</div>
																	{/* <div onClick={() => nvg('/delivery')} className="menu-item">Delivery Note</div> */}
																	<div onClick={() => nvg('/sales')} className="menu-item">Sales Invoice</div>
																	<div 
																	// onClick={() => nvg('/material')}
																	 className="menu-item">Material Request</div>
																	<div
																	//  onClick={() => nvg('/request')}
																	  className="menu-item">Request for Raw Materials</div>
																</div>
															)}
														</div>
						)}
						<Button
							onClick={handleDuplicate}
							className="createbtn d-flex"
							style={{ gap: "2px", height: "28px" }}
							iconName="GrCopy"
							iconSize={12}
						>
							Duplicate
						</Button>

						{fulldata?.message?.status === "Draft" &&
							po_status !== "submitted" && (
								<>
									<Button
										className="custom-btn-00989"
										onClick={handleSave}
										iconName="LuFilePlus2"
										style={{ gap: "2px", height: "28px" }}
										iconSize={12}
									>
										Update
									</Button>
									<Button
										className="custom-btn-bluecolor d-flex"
										iconName="BiCloudUpload"
										style={{ gap: "2px" }}
										iconSize={14}
										onClick={() => {
											setShowpopup(true);
										}}
									>
										Upload
									</Button>
								</>
							)}

						{fulldata?.message?.status === "Draft" &&
							po_status !== "submitted" && (
								<Button
									className="custom-btn-00989"
									onClick={handleSubmit}
									iconName="LuFilePlus2"
									style={{ gap: "2px", height: "28px" }}
									iconSize={12}
								>
									Submit
								</Button>
							)}
						{/* <Button
                        to="/inbound/purchaseorder/create-purchase-order"
                        className="px-2"
                        imgSrc={printerimg}

                        imgStyle={{ width: '21px' }}
                    >
                    </Button> */}
					</div>
				</div>
				<div
					className=""
					style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
				>
					<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
						<div className="d-flex justify-content-between align-items-end ">
							<ul
								className="nav nav-tabs mb-0"
								style={{ color: "white", border: "none" }}
							>
								<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={
											tab == 1
												? "nav-link active-tab-custom text-white border-radius-top-corner"
												: "nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										onClick={() => {
											settab(1);
										}}
										href="javascript:void(0);"
									>
										General Details
										{tab == 1 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
								<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
									<a
										className={
											tab == 2
												? "nav-link active-tab-custom text-white border-radius-top-corner"
												: "nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										onClick={() => {
											settab(2);
										}}
										href="javascript:void(0);"
									>
										Address & Contact{" "}
										{tab == 2 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
							</ul>
							<Attachment doctype="Sales Order" docname={salesorderId} />
						</div>
					</div>
					<div
						className="row d-flex justify-content-between"
						style={{ marginTop: "14px" }}
					>
						{/* className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px",  height: "70vh",overflowY: "scroll"}} */}
						<div
							className="col-3 sidebarbox"
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
								overflow: tab == 1 ? "" : "hidden",
							}}
						>
							<Tab1
								genaralData={genaralData}
								setTab1Data={setTab1Data}
								setTab1CustomerData={setTab1CustomerData}
								orderNo={orderNo}
								fieldErrors={fieldErrors}
								activityboll={activityboll}
								customer={customer}
								tab1Data={tab1Data}
								po_status={po_status}
								pTerms={{
									paymentterm: paymentterm,
									setpaymentterm: setpaymentterm,
									list: p_term?.data,
								}}
								price={{
									list: pricelist?.data,
									setvalue: setpricel,
									value: pricel,
								}}
								currency={{
									list: currencylist?.data,
									setvalue: setcurrency,
									value: currency,
								}}
								taxandchanges={{
									list: taxandchangeslist?.data,
									setvalue: settaxandchanges,
									value: taxandchanges,
								}}
								termandcondition={{
									termsandcondition,
									settermsandcondition,
									list: tandc?.data,
								}}
								cost_center={{
									list: costcenterlist?.data,
									setvalue: setcost_center,
									value: cost_center,
								}}
								project={{
									list: projectlist?.data,
									setvalue: setproject,
									value: project,
								}}
							/>
						</div>

						<div
							className="col-9 d-flex flex-column mt-2"
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
								minHeight: tab == 1 ? "440px" : "0",
							}}
						>
							<div className="d-flex" style={{ gap: "5px" }}>
								<div className="d-flex pb-2" style={{ gap: "5px" }}>
									<p className="NoOfLine">
										No. of lines -{" "}
										<span style={{ color: "#2563EB" }}>
											{" "}
											{selected_item_data.length}
										</span>
									</p>
									<p className="TotalQty">
										Total Quantity -{" "}
										<span style={{ color: "#16A34A" }}> {totalQuantity}</span>
									</p>
								</div>
							</div>
							<div className="tableLabel">
								<div
									style={{
										width: "98.5%",
										borderBottom: "1px solid #caced3",
										marginBottom: "6px",
									}}
								></div>
								<p
									style={{
										color: "#1E1E1E",
										fontWeight: "500",
										fontSize: "15px",
										marginBottom: "4px",
									}}
								>
									Item Details
								</p>
							</div>
							<Table
								setselected_item_data={setselected_item_data}
								rows={rows}
								setRows={setRows}
								list_data={getitem_list_data}
								po_status={po_status}
								allitems={allitems}
								fulldata={fulldata}
							/>

							{/* <div className="mt-auto pb-2">
								<div
									className="row"
									style={{ display: "flex", flexWrap: "wrap" }}
								>
									<div style={{ width: "20%" }}>
										<p className="TotalQtywithoutBg">
											Ordered Quantity -
											<span style={{ color: "#EC642A" }}>
												{selected_item_data.reduce(
													(sum, item) => sum + Number(item.quantity),
													0
												)}
											</span>
										</p>
									</div>

									<div style={{ width: "18%" }}>
										<p className="NoOfLinewithoutBg">
											Total Value -
											<span style={{ color: "#FF5969" }}>
												{selected_item_data.reduce(
													(sum, item) =>
														sum +
														Number(item.quantity * item.item.buying_price),
													0
												)}
											</span>
										</p>
									</div>

									<div style={{ width: "24%" }}>
										<p className="NoOfLinewithoutBg">
											Tax Type -<span style={{ color: "#C40AB8" }}>IGST</span>
										</p>
									</div>

									<div style={{ width: "15%" }}>
										<p className="NoOfLinewithoutBg">
											Tax -<span style={{ color: "#2563EB" }}>₹ 900.00</span>
										</p>
									</div>

									<div style={{ width: "22%" }}>
										<p className="NoOfLinewithoutBg">
											Grand Total -
											<span style={{ color: "#16A34A" }}>
												{selected_item_data.reduce(
													(sum, item) =>
														sum +
														Number(item.quantity * item.item.buying_price),
													0
												)}
											</span>
										</p>
									</div>
								</div>
							</div> */}


{console.log("check poo respo se is here",po_response)}

                            <div className=" mt-auto  pb-2" >
                                <div className="row ">
                                    <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        <div style={{ width: '20%' }}>
                                            <p className="TotalQtywithoutBg">
                                                Ordered Quantity -
                                                <span style={{ color: '#EC642A' }}>
                                                    {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '18%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Total Value -
                                                <span style={{ color: '#FF5969' }}>
                                                    {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.rate), 0)}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '24%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax Type -
                                                <span style={{ color: '#C40AB8' }}>
                                                    {fulldata.message?.taxes.length == 0 ? '' : fulldata.message?.taxes.reduce((acc, curr) => {
                                                                                        if (!acc.includes(curr.description)) {
                                                                                            acc.push(curr.description);
                                                                                        }
                                                                                        return acc;
                                                                                        }, []).join(', ')}
                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '15%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Tax -
                                                <span style={{ color: '#2563EB' }}>
                                                     {fulldata.message?.total_taxes_and_charges}

                                                </span>
                                            </p>
                                        </div>

                                        <div style={{ width: '22%' }}>
                                            <p className="NoOfLinewithoutBg">
                                                Grand Total -
                                                <span style={{ color: '#16A34A' }}>
                                                    {fulldata.message?.grand_total}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


						</div>
						<div
							className="col-12"
							style={{
								visibility: tab == 2 ? "visible" : "hidden",
								height: tab == 2 ? "auto" : "0px",
								overflow: tab == 2 ? "" : "hidden",
							}}
						>
							{" "}
							<Tab2
								tab1CustomerData={tab1CustomerData}
								setTab2Data={setTab2Data}
							/>{" "}
						</div>
						<div
							className="col-12"
							style={{
								visibility: tab == 3 ? "visible" : "hidden",
								height: tab == 3 ? "auto" : "0px",
								overflow: tab == 3 ? "" : "hidden",
							}}
						>
							{" "}
							<Tab3 />{" "}
						</div>
						<div
							className="col-12"
							style={{
								visibility: tab == 4 ? "visible" : "hidden",
								height: tab == 4 ? "auto" : "0px",
								overflow: tab == 4 ? "" : "hidden",
							}}
						>
							{" "}
							<Tab4 />{" "}
						</div>
					</div>
				</div>

				<ApiResponseBox
					poptype={ptype}
					show={showError}
					errorMessage={error}
					onClose={() => setShowError(false)}
				/>
				<BulkUpload
					show={showpopup}
					onClose={() => setShowpopup(false)}
					rows={rows}
					setRows={setRows}
					setselected_item_data={setselected_item_data}
				/>
			</>
		);
}

export default Salesform
